import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-downloadBtn",
  "use": "icon-downloadBtn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-downloadBtn\"><defs><style></style></defs><path d=\"M480 224a32 32 0 0 1 64 0v448a32 32 0 0 1-64 0z\" /><path d=\"M800 832V672a32 32 0 0 1 64 0v192a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V672a32 32 0 0 1 64 0v160z\" /><path d=\"M648.32 522.24a32 32 0 1 1 47.36 43.52l-176 192a32 32 0 0 1-47.36 0l-176-192a32 32 0 1 1 47.36-43.52L496 688.64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol